import { Linkedin, Mail } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

const IMAGES = [
  '/assets/denis-villeneuve.jpg',
  '/assets/jimmy-yu.jpg',
  '/assets/yan-yu.png',
];

export default function Team() {
  const { t } = useLang();
  const members = t('team.members');
  return (
    <section id="equipe" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="section-label mb-4">{t('team.label')}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mt-4">
            {t('team.title1')} <span className="yellow-underline">{t('team.title2')}</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {members.map((m, i) => (
            <div key={i} className="group relative overflow-hidden rounded-xl bg-white shadow-lg hover-lift flex flex-col">
              <div className="aspect-square overflow-hidden bg-gray-100">
                <img src={IMAGES[i]} alt={m.name}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-6 bg-brand-navy text-white">
                <div className="text-brand-yellow text-[11px] font-semibold tracking-widest uppercase mb-1">{m.role}</div>
                <div className="text-white text-xl font-bold">{m.name}</div>
                <p className="text-white/80 text-sm mt-3 leading-relaxed">{m.bio}</p>
                <div className="flex items-center gap-2 mt-4">
                  <a href="#" aria-label="LinkedIn" className="w-8 h-8 rounded-full bg-white/10 hover:bg-brand-yellow hover:text-brand-navy flex items-center justify-center text-white transition">
                    <Linkedin className="w-4 h-4" />
                  </a>
                  <a href="#contact" aria-label="Email" className="w-8 h-8 rounded-full bg-white/10 hover:bg-brand-yellow hover:text-brand-navy flex items-center justify-center text-white transition">
                    <Mail className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
